import { SliceZone } from '@prismicio/react';
import Copyright from './Copyright/Copyright';
import { components } from '@/slices';

import styles from './footer.module.scss';
import { Logo } from '../Logo/Logo';
import { FooterDocument } from '../../../prismicio-types';
import { BoxContainer } from '../BoxContainer/BoxContainer';

export const Footer = ({ page }: { page: FooterDocument<string> }) => {
  return (
    <footer>
      <BoxContainer styles={styles.footer}>
        <div className={styles.logo}>
          <Logo logo={page.data.logo} />
        </div>
        <Copyright companyName={page.data.copiryght_company_name} />
        <SliceZone slices={page.data.slices} components={components} />
      </BoxContainer>
    </footer>
  );
};
